/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Payload for getting project-level metrics summary
 */
export type GetProjectMetricsSummaryPayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export type GetProjectMetricsSummaryPayload$Outbound = {
  from: string;
  to: string;
};

/** @internal */
export const GetProjectMetricsSummaryPayload$outboundSchema: z.ZodMiniType<
  GetProjectMetricsSummaryPayload$Outbound,
  GetProjectMetricsSummaryPayload
> = z.object({
  from: z.pipe(z.date(), z.transform(v => v.toISOString())),
  to: z.pipe(z.date(), z.transform(v => v.toISOString())),
});

export function getProjectMetricsSummaryPayloadToJSON(
  getProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload,
): string {
  return JSON.stringify(
    GetProjectMetricsSummaryPayload$outboundSchema.parse(
      getProjectMetricsSummaryPayload,
    ),
  );
}
